export default __webpack_public_path__ + "static/media/people.8b3967a5.svg";